// The text a patient is sent when the office offers them times by text, with
// no link: nothing is held, and the patient answers by replying.
//
// The wording lives in offerMessage.ts with the rest of what a patient is
// sent, so it is one voice and one tested literal. This module is the name
// the modal has always called; the ownership guard there compares the reply
// box against whatever this produces, so the default changes everywhere at
// once.
//
// `pref` is no longer read. The practice's date and clock preference is for
// the practice; a patient reads "Mon, Oct 5 at 10:00 AM" whatever it is.
import { plainOfferText, OfferSlot } from './offerMessage';

export type OfferedSlot = OfferSlot;

// lead: a sentence the times follow rather than replace - after a
// cancellation, "your appointment was cancelled" has to survive the list.
export function slotsDraftMessage(slots: OfferedSlot[], _pref?: string | null, opts: { lead?: string | null } = {}): string {
  return plainOfferText(slots, opts);
}
